import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] grid place-items-center text-center px-6 fade-in" data-testid="page-404">
      <SEO title="Page not found" path="/404" />
      <div>
        <p className="font-mono-tech text-sm text-[#0066FF]">404</p>
        <h1 className="text-h1 mt-4">This page took a wrong turn.</h1>
        <p className="text-[#86868B] mt-3">The page you are looking for does not exist or was moved.</p>
        <Link to="/" className="btn-primary mt-8 inline-block">Back home</Link>
      </div>
    </div>
  );
}
